import { useRouter } from 'next/router'

import { routes } from '@routes'

export const Routes = {
  ...routes.Routes,
  ...routes.DynamicRoutes,
} as const

export type RouteName = keyof typeof Routes
export type Route = (typeof Routes)[RouteName]

export const useRouting = () => {
  const router = useRouter()

  const push = (route: Route) => router.push(route)

  return {
    push,
    pathname: router?.pathname as Route,
  }
}

// TODO: Incorporate this functionality into a `<Link>`
